document.addEventListener("DOMContentLoaded", () => {
    onetick_event();
    subscription_event();
    var product_variant_cards = document.querySelectorAll(".custom-option-list .product-variant-card");
    product_variant_cards.forEach(item => {
        item.addEventListener("click", () => {
            var variant_label = item.dataset.label;
            document.querySelector(".custom-option-list .product-variant-card.active .selected_variant_input.active").classList.remove("active");
            document.querySelector(".custom-option-list .product-variant-card.active").classList.remove("active");
            item.classList.add("active");
            item.querySelector(".selected_variant_input").classList.add("active");
            document.querySelector(`.product-variant-picker__pill-list label[data-option-value="${variant_label}"]`).click();
        })
    })
    var add_to_cart = document.querySelector(".product__info product-form .product-form__btns ");
    var sticky_add_to_cart = document.querySelector(".product__info product-form .product-form__btns");
    if(add_to_cart){
        add_to_cart.addEventListener("click", () => {
            if(document.querySelector(".product__info product-form .product-form__btns .product_main_button_hidden .product-form__btn")){
            document.querySelector(".product__info product-form .product-form__btns .product_main_button_hidden .product-form__btn").click();
            }
        });
    }
    if(sticky_add_to_cart){
    sticky_add_to_cart.addEventListener("click", () => {
            if(document.querySelector(".product__info product-form .product-form__btns .product_main_button_hidden .product-form__btn")){
        document.querySelector(".product__info product-form .product-form__btns .product_main_sticky_button_hidden .product-form__btn").click();
            }
    });
}
    function onetick_event() {
        var timer;
        var current_price_element = document.querySelector(".product__info product-form .product-form__btns .current_product_total");
        var current_price_element_mobile = document.querySelector(".product__info product-form .product-form__btns .current_product_total");
        var current_total_price = current_price_element.innerHTML;
        timer = setInterval(() => {
            var onetick = document.querySelector("onetick-group-checkboxes onetick-checkbox label.onetick-checkbox input");
            if(onetick){
                clearInterval(timer);
                var onetick_price = document.querySelector("onetick-group-checkboxes onetick-checkbox .onetick-price").innerHTML;
                if(onetick.checked){
                    var total_price = (parseFloat(onetick_price) + parseFloat(current_total_price)).toFixed(2);
                    current_price_element.innerHTML = total_price;
                    current_price_element_mobile.innerHTML = total_price;
                }
                onetick.addEventListener("change", () => {
                    var current_quantity = document.querySelector(".product__info quantity-component .quantity__input").value;
                    var selected_purchase_option = document.querySelector(".loop-widget-container .loop-widget-purchase-options-container .loop-widget-purchase-option.loop-widget-purchase-option-selected .loop-widget-purchase-option-price");
                    var remove_currency = 0;  
                    if(selected_purchase_option){
                    remove_currency = selected_purchase_option.innerHTML.replace("$", "");  
                    }else {
                    remove_currency = current_total_price;
                    }
                    var total_price = (parseFloat(onetick_price) + (parseInt(current_quantity) * parseFloat(remove_currency))).toFixed(2);
                    if(onetick.checked){
                        current_price_element.innerHTML = total_price;
                        current_price_element_mobile.innerHTML = total_price
                    }else {
                        current_price_element.innerHTML = (parseInt(current_quantity) * parseFloat(remove_currency)).toFixed(2);
                        current_price_element_mobile.innerHTML = (parseInt(current_quantity) * parseFloat(remove_currency)).toFixed(2);
                    }
                })
            }
        }, 1000);
    }
    function subscription_event() {
        var timer;
        var current_price_element = document.querySelector(".product__info product-form .product-form__btns .current_product_total");
        var current_price_element_mobile = document.querySelector(".product__info product-form .product-form__btns .current_product_total");
        var current_total_price = current_price_element.innerHTML;
        timer = setInterval(() => {
            var loop_widget_container = document.querySelectorAll(".loop-widget-container .loop-widget-purchase-options-container .loop-widget-purchase-option");
            var onetick = document.querySelector("onetick-group-checkboxes onetick-checkbox label.onetick-checkbox input");
            // console.log(loop_widget_container);
            if(loop_widget_container.length > 0 && onetick){
                clearInterval(timer);
                var selected_purchase_option = document.querySelector(".loop-widget-container .loop-widget-purchase-options-container .loop-widget-purchase-option.loop-widget-purchase-option-selected .loop-widget-purchase-option-price");
                
                var remove_currency = selected_purchase_option.innerHTML.replace("$", "");
                var onetick_price = document.querySelector("onetick-group-checkboxes onetick-checkbox .onetick-price").innerHTML;
                var change_price = 0;
                if(onetick.checked){
                    change_price = (parseFloat(remove_currency) + parseFloat(onetick_price)).toFixed(2);
                }else {
                    change_price = remove_currency;
                }
                current_price_element.innerHTML = change_price; 
                current_price_element_mobile.innerHTML = change_price;
                loop_widget_container.forEach(item => {
                    item.addEventListener("click", () => {
                        
                        var current_quantity = document.querySelector(".product__info quantity-component .quantity__input").value;
                        var item_price = item.querySelector(".loop-widget-purchase-option-price").innerHTML.replace("$", "");
                        if(onetick.checked){
                            change_price = (parseFloat(onetick_price) + (parseFloat(item_price) * parseInt(current_quantity))).toFixed(2);
                        }else {
                            change_price = (parseFloat(item_price) * parseInt(current_quantity)).toFixed(2);
                        }
                        console.log(item_price, change_price);
                        current_price_element.innerHTML = change_price;
                        current_price_element_mobile.innerHTML = change_price;
                    })
                })
            }
        }, 1000);
    }

//======================= START: Show Custom Essential widget ======================
// var interval = setInterval(function() {
// var axeInput = document.querySelector('.axe-checkbox-upsell-list .axe-main-1.axe-border-width-none input');
//     if (axeInput) {
//         var widget = document.querySelector('.custom_subscription_option');  
//         if (widget) {
//             widget.style.setProperty('display', 'flex', 'important');
//             var checkbox = document.querySelector('.custom_subscription_option .subscription_option');
//             if (checkbox) {
//                 checkbox.addEventListener('click', function(event) {
//                     const parentDiv = event.target.closest('.essential_subscription_widget');
//                     if (!parentDiv) return;
//                     const essentials = parentDiv.querySelector('.essentials-container');
//                     if (essentials) {
//                         essentials.style.display = event.target.checked ? 'block' : 'none';
//                     }
//                     var axeTriggerInput = document.querySelector('.axe-checkbox-upsell-list .axe-main-1.axe-border-width-none input');
//                     axeTriggerInput.checked = event.target.checked;
//                     axeTriggerInput.dispatchEvent(new Event("change", { bubbles: true }));
//                 });
//             }
//         }
//     clearInterval(interval); 
//     }   
// }, 100);


    //======================= END: Show Custom widget ======================

    // ============== START: Update ATC button price ==================
    function updateATCButtonPrice() {
        const checkedSubscription = document.querySelector('.loop-widget-purchase-options-container');
        if (!checkedSubscription) return;
        const loopSubscriptionTotalEl = checkedSubscription.querySelector('.loop-widget-purchase-option-selected .loop-widget-purchase-option-price');
        const loopSubscriptionPrice = loopSubscriptionTotalEl ? loopSubscriptionTotalEl.textContent.trim() : '';
        // Update the button
        setTimeout(() => {
            const totalEl = document.querySelector('.product-form__btn .current_product_total');
            if (totalEl) {
                totalEl.textContent = loopSubscriptionPrice;
            }
        }, 100);
        
        const productOriginalPrice = document.querySelector("product-info .product-price__current-price");
        if (productOriginalPrice) {
            productOriginalPrice.textContent = loopSubscriptionPrice;
        }
        
        const stickyCartPrice = document.querySelector(".product-form__mobile-sticky-button .current_product_total");
         if (stickyCartPrice) {
            stickyCartPrice.textContent = loopSubscriptionPrice;
        }
    }

    var loopInterval = setInterval(function() {
        const loopSubscriptionRadios = document.querySelectorAll('.loop-widget-purchase-options-container .loop-widget-purchase-option');

        if(loopSubscriptionRadios.length > 0){
            updateATCButtonPrice();
            loopSubscriptionRadios.forEach(subscriptionRadio => {
                subscriptionRadio.addEventListener('click', function() {
                    updateATCButtonPrice();
                });
            });
            clearInterval(loopInterval);
        }
    }, 100);
    // ============== END: Update ATC button price ====================
});